import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import GuardiaScheda from "@/components/GuardiaScheda";
import Tesserino from "@/components/Tesserino";
import DocumentiPersonali from "@/components/DocumentiPersonali";
import ScadenzeBanner from "@/components/ScadenzeBanner";
import { Card, CardContent } from "@/components/ui/card";

export default function MiaScheda() {
  const { data: g, isLoading, isError } = useQuery({
    queryKey: ["guardia-me"],
    queryFn: async () => (await api.get("/guardie/me")).data,
    retry: false,
  });

  if (isLoading) return <p className="text-sm text-slate-400">Caricamento…</p>;
  if (isError || !g)
    return (
      <Card className="border-dashed">
        <CardContent className="py-12 text-center text-sm text-slate-500">
          Nessuna scheda guardia collegata al tuo account. Contatta il coordinatore.
        </CardContent>
      </Card>
    );

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">La mia scheda</h1>
        <p className="mt-1 text-sm text-slate-500">Tesserino digitale e dati personali.</p>
      </div>
      <ScadenzeBanner />
      <GuardiaScheda g={g} />
      <div className="mt-6"><Tesserino g={g} /></div>
      <DocumentiPersonali guardiaId={g.id} />
    </div>
  );
}
